export default "__VITE_ASSET__BQdjnhEt__"